import { useProductsClosedApi } from 'src/api/db/apiProductsClosed'

export const useDraftProduct = (productToUpdate, products) => {
  // Determine which productId to use: if productToUpdate is undefined, look for a draft product, otherwise use productToUpdate
  let productId: number | undefined = undefined
  let draftProduct: any = undefined

  if (typeof productToUpdate === 'undefined') {
    draftProduct = products?.data?.find(
      // @ts-ignore
      (product) => product.is_draft === true
    )
    productId = draftProduct?.id
  } else {
    productId = productToUpdate
  }

  return productId
}

